/* bloomerie Scroll-Effekte (10.10.2026)
   Ueberschriften steigen beim Scrollen auf und werden scharf, grosse Bilder zoomen sanft auf ihre Groesse.
   Beides folgt direkt der Scrollposition (auch rueckwaerts), wie auf apple.com.
   Elemente, die beim Laden schon im Bild sind, bleiben ruhig stehen. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const TITLES = '.bl-sd-title, h2.title.inline-richtext, .rich-text__heading, .image-with-text__heading';
  const IMAGES = '.bl-sd-zoom img, .image-with-text__media img';
  const active = new Set();
  let queued = false;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => (entry.isIntersecting ? active.add(entry.target) : active.delete(entry.target)));
      queue();
    },
    { rootMargin: '15% 0px 15% 0px' }
  );

  // 0 = Oberkante am unteren Bildschirmrand, 1 = Oberkante bei `end` (Anteil der Bildschirmhoehe)
  function progress(el, end) {
    const vh = window.innerHeight;
    const top = el.getBoundingClientRect().top;
    return Math.min(1, Math.max(0, (vh - top) / (vh - vh * end)));
  }

  function apply(el) {
    const isImage = el.classList.contains('bl-sd-z');
    const p = isImage ? progress(el.parentElement, 0.2) : progress(el, 0.62);
    el.style.setProperty('--bl-p', p.toFixed(3));
  }

  function update() {
    queued = false;
    active.forEach(apply);
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }

  function register(el, cls) {
    if (el.dataset.blSd) return;
    el.dataset.blSd = '1';
    // schon beim Laden sichtbar: nicht animieren
    if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
    el.classList.add('bl-sd-on', cls);
    apply(el);
    io.observe(el);
  }

  function setup(root = document) {
    root.querySelectorAll(TITLES).forEach((el) => register(el, 'bl-sd-t'));
    root.querySelectorAll(IMAGES).forEach((el) => register(el, 'bl-sd-z'));
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
